import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchProducts = createAsyncThunk("product/fetchProducts", async () => {
  const res = await api.products.getAll();
  return res.data.data;
});
